export default __webpack_public_path__ + "static/media/Melinda Liu.945dac11.jpg";